"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync } from "vue-property-decorator";
import { DrawerComponent } from "@/components/core";
import UiDrawer from "@/components/drawer/UiDrawer.vue";
import draggable from "vuedraggable";
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import _ from "lodash";
import i18n from "@/lang";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import API from "@ym-framework/api-utils";
import { Debounce } from "vue-debounce-decorator";
class AdvancedSearchFormConfig {
  constructor() {
    this._groups = [];
    this._ebusinesses = [];
    this._users = [];
    this._status = [
      {
        label: i18n.t("vdadvancedsearch.normal"),
        value: "open"
      },
      {
        label: i18n.t("vdadvancedsearch.lock"),
        value: "lock"
      },
      {
        label: i18n.t("vdadvancedsearch.to_be_opened"),
        value: "wait"
      },
      {
        label: i18n.t("vdadvancedsearch.to_be_released_soon"),
        value: "expired"
      },
      {
        label: i18n.t("vdadvancedsearch.environment_configuration"),
        value: "configuring"
      }
    ];
  }
  ready() {
    return __async(this, null, function* () {
      const _that = this;
      yield Promise.all(
        function* () {
          yield new Promise((resolve, reject) => __async(this, null, function* () {
            const response = yield API.get(
              `api://base.auth/api/v7/orgs/ebusinesses`
            );
            _that._ebusinesses = response.data.datas;
            resolve(_that._ebusinesses);
          }));
          yield new Promise((resolve, reject) => __async(this, null, function* () {
            const response = yield API.get(`api://base.auth/api/v7/shops/owners`);
            _that._users = response.data.datas;
            resolve(_that._users);
          }));
        }()
      );
    });
  }
  ebusinesses() {
    return this._ebusinesses;
  }
  groups() {
    return this._groups;
  }
  users() {
    return this._users;
  }
  status() {
    return this._status;
  }
}
let AdvancedSearchFormDrawer = class extends DrawerComponent {
  constructor() {
    super(...arguments);
    // @PropSync("owner")
    // public _owner!: VirtualDesktopContentController;
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ]
    };
    // public formData = new AdvancedSearchForm();
    this.config = new AdvancedSearchFormConfig();
  }
  get $query() {
    return this._query;
  }
  created() {
    return __async(this, null, function* () {
      this.config.ready();
    });
  }
  search() {
    return __async(this, null, function* () {
      if (this.$query.name) {
        if (this.$query.name.length > 100) {
          this.$message.error(this.$t("loginlogs.vd_name_too_long"));
          return;
        }
      }
      if (this.$query.ip) {
        let pattern = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/g;
        if (!pattern.test(this.$query.ip) || this.$query.ip === "") {
          this.$message.error(this.$t("loginlogs.ip_worng"));
          return;
        }
      }
      if (this.$query.expiryDate !== null && this.$query.expiryDate.length === 2) {
        this.$query.loginStartTime = this.$query.expiryDate[0];
        this.$query.loginEndTime = this.$query.expiryDate[1];
      } else {
        this.$query.loginStartTime = null;
        this.$query.loginEndTime = null;
      }
      _.set(this.$query, "keyword", null);
      if (this.$query.name === null) {
        this.$query.name = "";
      }
      this.$emit("search", this.$query);
    });
  }
  // owner: VirtualDesktopContentController
  static create(query) {
    const _vue = new this({
      i18n,
      el: document.createElement("div"),
      propsData: {
        query
      }
    });
    return _vue;
  }
  clearDrawer() {
    return __async(this, null, function* () {
      this.$query.clear();
      yield this.search();
    });
  }
};
__decorateClass([
  PropSync("query")
], AdvancedSearchFormDrawer.prototype, "_query", 2);
__decorateClass([
  Debounce(800)
], AdvancedSearchFormDrawer.prototype, "search", 1);
AdvancedSearchFormDrawer = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDrawer,
      ItemShop,
      draggable
    }
  })
], AdvancedSearchFormDrawer);
export {
  AdvancedSearchFormDrawer as default
};
